import { GetTimelineDropTargetArgs } from '@modules/timetable';

export const getTimelineDropTarget = ({ x, y }: GetTimelineDropTargetArgs): Element | null => {
  // First neutralize other timeline items so that they won't be picked up by elementFromPoint
  const existingTimelineItemElements = Array.from(
    document.getElementsByClassName('rct-item') as HTMLCollectionOf<HTMLElement>,
  );
  existingTimelineItemElements.forEach((itemElement) => {
    // eslint-disable-next-line no-param-reassign
    itemElement.style.pointerEvents = 'none';
  });

  // Get the react dnd droppable target which the item was dropped on
  const dropTarget = document.elementFromPoint(x, y);

  existingTimelineItemElements.forEach((itemElement) => {
    // eslint-disable-next-line no-param-reassign
    itemElement.style.pointerEvents = 'auto';
  });

  return dropTarget;
};
